"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showCPUPressureNotification = showCPUPressureNotification;
var _actions = require("../actions");
/**
 * @description Show a notification when the CPU is under pressure.
 * @param data
 * @param modal
 * @param localSource
 * @param dispatch
 */
function showCPUPressureNotification(data, modal, localSource, dispatch) {
  function editLocalCameraSource() {
    dispatch((0, _actions.showModal)(modal, localSource));
    dispatch((0, _actions.clearNotification)());
  }
  console.warn('CPU Under Pressure Alert', data);
  dispatch((0, _actions.showNotification)('We recommend turning off your virtual background to avoid interruptions.', {
    linkMessage: 'Turn background off',
    onClick: editLocalCameraSource,
    type: 'warning',
    timeout: 10000
  }));
}